module.exports = "/images/marking-icon-checkbox-unchecked_new.svg?d494b3e6bec9f7d4a553c80ffc5b306b";